import { useTranslation } from 'react-i18next';

import { TextareaField } from 'fields';

export default function Notes() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  return (
    <TextareaField
      name="customerNotes"
      label={t('labels.notes')}
      placeholder={t('placeholders.notes')}
    />
  );
}
